export const rulesOrderStatus = {
  ORDERED: [
    'ORDERED',
    'DELIVERED_TO_POST',
    'SUPPLIED_IN_CENTER',
    'DELIVERED',
    ,
  ],
  ARRIVED: ['ARRIVED', 'DELIVERED', 'NOT_DELIVERED'],
  BUNDLED: [
    'BUNDLED',
    'LOADED',
    'ARRIVED',
    'DELIVERED_TO_CENTER',
    'DELIVERED',
    'NOT_DELIVERED',
    'RETURNED',
  ],
  CANCELLED: ['CANCELLED'],
  DELIVERED_TO_POST: ['DELIVERED_TO_POST', 'DELIVERED_TO_CENTER', , 'PACKAGED'],
  DELIVERED_TO_CENTER: [
    'DELIVERED_TO_CENTER',
    'SUPPLIED_IN_CENTER',
    'DELIVERED',
    'NOT_DELIVERED',
    ,
  ],
  SUPPLIED_IN_CENTER: ['SUPPLIED_IN_CENTER', 'DELIVERED', 'NOT_DELIVERED', ,],
  // PACKAGED: [
  //   'PACKAGED',
  //   'BUNDLED',
  //   'LOADED',
  //   'ARRIVED',
  //   'DELIVERED_TO_CENTER',
  //   'DELIVERED_TO_POST',
  //   'DELIVERED',
  //   'NOT_DELIVERED',
  //   'RETURNED',
  // ],
  DELIVERED: ['DELIVERED', 'RETURNED', 'NOT_DELIVERED'],
  LOADED: ['LOADED', 'PACKAGED', 'DELIVERED', 'NOT_DELIVERED'],
  NOT_DELIVERED: ['NOT_DELIVERED', 'DELIVERED', 'RETURNED'],
  RETURNED: ['RETURNED', 'NOT_DELIVERED', 'DELIVERED'],
  PACKAGED: ['DELIVERED', 'NOT_DELIVERED', 'RETURNED'],

  REGISTERED_IN_3PL: ['DELIVERED', 'NOT_DELIVERED', 'RETURNED', 'PACKAGED'],
  REGISTERING_IN_3PL: ['DELIVERED', 'NOT_DELIVERED', 'RETURNED', 'PACKAGED'],
  DELIVERING: ['DELIVERED', 'NOT_DELIVERED', 'RETURNED', 'PACKAGED'],
  DELIVERED_TO_3PL: ['DELIVERED', 'NOT_DELIVERED', 'RETURNED', 'PACKAGED'],
  DELIVERED_TO_3PL_COURIER: [
    'DELIVERED',
    'NOT_DELIVERED',
    'RETURNED',
    'PACKAGED',
  ],
  CANCELED_FROM_3PL: ['DELIVERED', 'NOT_DELIVERED', 'RETURNED', 'PACKAGED'],
  AWAITING_REVIEW: ['DELIVERED', 'NOT_DELIVERED', 'RETURNED', 'PACKAGED'],
} as any;

export const rulesPostOrderStatus = {
  DONE: ['DRAFT', 'QUEUE'],
  DRAFT: ['DONE', 'QUEUE'],
  QUEUE: ['DRAFT', 'DONE'],
} as any;
export const rulesAdminChangeOrderStatus = {
  CENTER_ADMIN: [
    'DELIVERED_TO_CENTER',
    'PACKAGED',
    'DELIVERED',
    'NOT_DELIVERED',
    'RETURNED',

    'REGISTERED_IN_3PL',
    'REGISTERING_IN_3PL',
    'DELIVERING ',
    'DELIVERED_TO_3PL ',
    'DELIVERED_TO_3PL_COURIER ',
    'CANCELED_FROM_3PL ',
    'AWAITING_REVIEW',
  ],
  RONAD_ADMIN: [
    'DELIVERED_TO_POST',
    'DELIVERED_TO_CENTER',
    'PACKAGED',
    'LOADED',
    'ARRIVED',
    'DELIVERED',
    'NOT_DELIVERED',
    'NOT_DELIVERED',
    'RETURNED',
    'CANCELLED',

    'REGISTERED_IN_3PL',
    'REGISTERING_IN_3PL',
    'DELIVERING ',
    'DELIVERED_TO_3PL ',
    'DELIVERED_TO_3PL_COURIER ',
    'CANCELED_FROM_3PL ',
    'AWAITING_REVIEW',
  ],
  MARKETING_MANAGER: [
    'DELIVERED_TO_POST',
    'DELIVERED_TO_CENTER',
    'PACKAGED',
    'LOADED',
    'ARRIVED',
    'DELIVERED',
    'NOT_DELIVERED',
    'NOT_DELIVERED',
    'RETURNED',
    'CANCELLED',

    'REGISTERED_IN_3PL',
    'REGISTERING_IN_3PL',
    'DELIVERING ',
    'DELIVERED_TO_3PL ',
    'DELIVERED_TO_3PL_COURIER ',
    'CANCELED_FROM_3PL ',
    'AWAITING_REVIEW',
  ],
  MARKETING_EXPERT: [
    'DELIVERED_TO_POST',
    'DELIVERED_TO_CENTER',
    'PACKAGED',
    'LOADED',
    'ARRIVED',
    'DELIVERED',
    'NOT_DELIVERED',
    'NOT_DELIVERED',
    'RETURNED',
    'CANCELLED',

    'REGISTERED_IN_3PL',
    'REGISTERING_IN_3PL',
    'DELIVERING ',
    'DELIVERED_TO_3PL ',
    'DELIVERED_TO_3PL_COURIER ',
    'CANCELED_FROM_3PL ',
    'AWAITING_REVIEW',
  ],
  OPERATIONS_MANAGER: [
    'DELIVERED_TO_POST',
    'DELIVERED_TO_CENTER',
    'PACKAGED',
    'LOADED',
    'ARRIVED',
    'DELIVERED',
    'NOT_DELIVERED',
    'NOT_DELIVERED',
    'RETURNED',
    'CANCELLED',

    'REGISTERED_IN_3PL',
    'REGISTERING_IN_3PL',
    'DELIVERING ',
    'DELIVERED_TO_3PL ',
    'DELIVERED_TO_3PL_COURIER ',
    'CANCELED_FROM_3PL ',
    'AWAITING_REVIEW',
  ],
  WAREHOUSE_ADMIN: [
    'DELIVERED_TO_POST',
    'DELIVERED_TO_CENTER',
    'PACKAGED',
    'LOADED',
    'ARRIVED',
    'DELIVERED',
    'NOT_DELIVERED',
    'NOT_DELIVERED',
    'RETURNED',
    'CANCELLED',

    'REGISTERED_IN_3PL',
    'REGISTERING_IN_3PL',
    'DELIVERING ',
    'DELIVERED_TO_3PL ',
    'DELIVERED_TO_3PL_COURIER ',
    'CANCELED_FROM_3PL ',
    'AWAITING_REVIEW',
  ],
  OPERATIONS_EXPERT: [
    'DELIVERED_TO_POST',
    'DELIVERED_TO_CENTER',
    'PACKAGED',
    'LOADED',
    'ARRIVED',
    'DELIVERED',
    'NOT_DELIVERED',
    'NOT_DELIVERED',
    'RETURNED',
    'CANCELLED',

    'REGISTERED_IN_3PL',
    'REGISTERING_IN_3PL',
    'DELIVERING ',
    'DELIVERED_TO_3PL ',
    'DELIVERED_TO_3PL_COURIER ',
    'CANCELED_FROM_3PL ',
    'AWAITING_REVIEW',
  ],
  SUPPORT_MANAGER: [
    'DELIVERED_TO_POST',
    'DELIVERED_TO_CENTER',
    'PACKAGED',
    'LOADED',
    'ARRIVED',
    'DELIVERED',
    'NOT_DELIVERED',
    'NOT_DELIVERED',
    'RETURNED',
    'CANCELLED',

    'REGISTERED_IN_3PL',
    'REGISTERING_IN_3PL',
    'DELIVERING ',
    'DELIVERED_TO_3PL ',
    'DELIVERED_TO_3PL_COURIER ',
    'CANCELED_FROM_3PL ',
    'AWAITING_REVIEW',
  ],
  AGENCY_ADMIN: [
    'DELIVERED_TO_POST',
    'DELIVERED_TO_CENTER',
    'PACKAGED',
    'LOADED',
    'ARRIVED',
    'DELIVERED',
    'NOT_DELIVERED',
    'NOT_DELIVERED',
    'RETURNED',
    'CANCELLED',

    'REGISTERED_IN_3PL',
    'REGISTERING_IN_3PL',
    'DELIVERING ',
    'DELIVERED_TO_3PL ',
    'DELIVERED_TO_3PL_COURIER ',
    'CANCELED_FROM_3PL ',
    'AWAITING_REVIEW',
  ],
  SUPPORT_EXPERT: [
    'DELIVERED_TO_POST',
    'DELIVERED_TO_CENTER',
    'PACKAGED',
    'LOADED',
    'ARRIVED',
    'DELIVERED',
    'NOT_DELIVERED',
    'NOT_DELIVERED',
    'RETURNED',
    'CANCELLED',

    'REGISTERED_IN_3PL',
    'REGISTERING_IN_3PL',
    'DELIVERING ',
    'DELIVERED_TO_3PL ',
    'DELIVERED_TO_3PL_COURIER ',
    'CANCELED_FROM_3PL ',
    'AWAITING_REVIEW',
  ],
  // LOGISTICS_ADMIN: ['LOADED', 'ARRIVED', 'NOT_DELIVERED'],
  LOGISTICS_ADMIN: [
    'BUNDLED',
    'LOADED',
    'ARRIVED',
    'PACKAGED',
    'DELIVERED_TO_CENTER',
    'DELIVERED_TO_POST',
    'DELIVERED',
    'NOT_DELIVERED',
    'RETURNED',
    'CANCELLED',

    'REGISTERED_IN_3PL',
    'REGISTERING_IN_3PL',
    'DELIVERING ',
    'DELIVERED_TO_3PL ',
    'DELIVERED_TO_3PL_COURIER ',
    'CANCELED_FROM_3PL ',
    'AWAITING_REVIEW',
  ],

  NONE: ['PACKAGED'],
} as any;
